export default "__VITE_ASSET__Cud3RYyM__"